module.exports = __webpack_public_path__ + "static/littleWomen8-c44933ba1ed0507290f453fb6e391d3b.jpg";